import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomModalService } from '@shared/services';

@Component({
  selector: 'sd-add-company-modal',
  templateUrl: './add-company-modal.component.html',
  styleUrls: ['./add-company-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdAddCompanyModalComponent {
  constructor(public modalService: CustomModalService) {}
}
